var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon-lock_svg__a",
    d: "M18.545 11.182H16.91V7.909a4.91 4.91 0 00-9.82.001v3.272H5.456A2.454 2.454 0 003 13.636v4.91A2.454 2.454 0 005.455 21h13.09A2.454 2.454 0 0021 18.545v-4.909a2.453 2.453 0 00-2.455-2.454zM8.727 7.909a3.274 3.274 0 016.546 0v3.273H8.727V7.909zm10.637 10.636a.82.82 0 01-.819.819H5.455a.82.82 0 01-.819-.819v-4.909c0-.452.367-.818.819-.818h13.09c.452 0 .819.366.819.818v4.91z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#18212D",
    fillRule: "nonzero",
    xlinkHref: "#icon-lock_svg__a"
  })));
}

export default SvgIconLock;